export const EVENT_TYPES = {
  // Session Events
  SESSION_START: 'session_start',
  SESSION_END: 'session_end',
  USER_INACTIVE: 'user_inactive',
  
  // Page Events
  PAGE_VIEW: 'page_view',
  PAGE_EXIT: 'page_exit',
  PAGE_HIDDEN: 'page_hidden',
  PAGE_VISIBLE: 'page_visible',
  
  // User Interactions
  USER_INTERACTION: 'user_interaction',
  BUTTON_CLICK: 'button_click',
  FORM_SUBMIT: 'form_submit',
  SEARCH: 'search',
  FILTER: 'filter',
  EXPORT: 'export',
  
  // Feature Usage
  WIDGET_CREATE: 'widget_create',
  CANVAS_CREATE: 'canvas_create',
  PAYMENT_ATTEMPT: 'payment_attempt',
  SUBSCRIPTION_CHANGE: 'subscription_change',
  
  // Performance
  COMPONENT_MOUNT: 'component_mount',
  COMPONENT_UNMOUNT: 'component_unmount',
  API_CALL: 'api_call',
  
  // Errors
  ERROR: 'error',
  API_ERROR: 'api_error',
  
  // Network
  CONNECTION_LOST: 'connection_lost',
  CONNECTION_RESTORED: 'connection_restored'
};

export const INTERACTION_TYPES = {
  CLICK: 'click',
  SEARCH: 'search',
  FILTER: 'filter',
  EXPORT: 'export',
  NAVIGATION: 'navigation',
  FORM_INTERACTION: 'form_interaction'
};

export const PAGE_CATEGORIES = {
  PUBLIC: 'public',
  AUTH: 'auth',
  DASHBOARD: 'dashboard',
  SETTINGS: 'settings',
  ADMIN: 'admin',
  SUBSCRIPTION: 'subscription',
  CANVAS: 'canvas',
  SETUP: 'setup',
  AI: 'ai',
  OTHER: 'other'
};